module.exports = __webpack_public_path__ + "assets/img/portfolio-big-08.d1719517.png";